import { MATERIAL, MODEL_ID, POLYCOUNT_MODE, PROVIDER } from 'Pods/ThreeDStudio/Store/constants'

/**
 * Inverse of parseMeshyTextTo3dProData. Builds an openedModel-shaped payload
 * from the current modelSettings so the just-submitted run can be reopened
 * without an extra API round-trip.
 *
 * @param {Object} state - ThreeDStudio store state (getState())
 * @param {string|number} id - Run id from the generation API response
 * @returns {Object} - openedModel payload accepted by parseMeshyTextTo3dProData
 */
export const buildMeshyTextTo3dProFromState = (state, id) => {
  const { modelSettings } = state
  const {
    prompt,
    material,
    targetPolycount,
    polygonType,
    isPrivate,
    isUnlimitedPolycount,
    selectedUseCase,
  } = modelSettings || {}

  return {
    id,
    providerKey: PROVIDER.MESHY,
    providerModelId: MODEL_ID.MESHY_TEXT_TO_3D_PRO,
    prompt,
    enablePbr: material === MATERIAL.PBR,
    geometryOnly: material === MATERIAL.GEOMETRY_ONLY,
    private: isPrivate,
    useCase: selectedUseCase,
    providerRunAttributes: {
      ...(targetPolycount != null && { target_polycount: targetPolycount }),
      ...(isUnlimitedPolycount && { polycount_mode: POLYCOUNT_MODE.UNLIMITED }),
      ...(polygonType != null && { topology: polygonType }),
    },
  }
}
